import Stack, { StackProps } from 'src/app/atoms/Layout/Stack/Stack';
import { cssVar } from 'src/app/styles/helper';
import styled, { css } from 'styled-components';
import { ColorModeBorderPropKeys } from 'styles/colors';

interface PriceBlockContainerProps extends StackProps {
  $minHeight?: number;
  $priceBlockBorder?: ColorModeBorderPropKeys;
}

export const PriceBlockContainer = styled(Stack)<PriceBlockContainerProps>`
  border-bottom: 1px solid ${({ $priceBlockBorder = 'border-secondary' }) => cssVar($priceBlockBorder)};
  height: fit-content;

  ${({ $minHeight }) =>
    $minHeight &&
    css`
      min-height: ${$minHeight}px;
    `}

  .period {
    margin-bottom: ${cssVar('spacing-sm')};
  }
`;
